<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-button
        @click="backLastPage"
        type="primary"
        style="margin-bottom:24px"
        icon="arrow-left"
        >返回</a-button
      >
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="基金代码">
              <a-input
                placeholder="请输入基金代码"
                v-model="fundCode"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- table区域-begin -->

    <a-table
      ref="table"
      :scroll="{ x: 1150 }"
      bordered
      rowKey="sharesCode"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
    </a-table>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';

export default {
  name: 'FiveBonds',

  data() {
    return {
      fundCode: '',
      dataSource: [],
      uploading: false,
      loading: false,
      // 表头
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'serialNumber',
          ellipsis: true,
          width: 80
        },
        {
          title: '基金代码',
          align: 'center',
          dataIndex: 'fundCode',
          ellipsis: true,
          width: 120
        },
        {
          title: '债券代码',
          align: 'center',
          width: 200,
          ellipsis: true,
          dataIndex: 'sharesCode'
        },
        {
          title: '债券名称',
          align: 'center',
          width: 200,
          ellipsis: true,
          dataIndex: 'sharesName'
        },
        {
          title: '债券数量(张)',
          align: 'center',
          width: 180,
          dataIndex: 'number',
          ellipsis: true
        },
        {
          title: '公允价值（股）',
          align: 'center',
          width: 180,
          dataIndex: 'fairValue',
          ellipsis: true
        },
        {
          title: '占基金比例',
          align: 'center',
          width: 200,
          ellipsis: true,
          dataIndex: 'scale'
        }
      ],

      url: {
        bondsList: process.env.VUE_APP_CMS_PRODUCT + '/product/sdgp/list'
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },

  methods: {
    initFundCode(record) {
      this.fundCode = record.fundCode;
      this.getList();
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageSize: that.ipagination.pageSize,
        pageNo: that.ipagination.current,
        fundCode: this.fundCode,
        type: 1
      };
      that.loading = true;
      getAction(this.url.bondsList, params).then(res => {
        that.loading = false;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    backLastPage() {
      this.$emit('handelColse', 'isFiveBonds');
    },

    //搜素
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.fundCode = '';
      this.getList(1);
    },

    //分页
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      this.ipagination = pagination;
      this.getList();
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
